import {
  BouncerWrapperStyled,
  BouncerDotStyled,
  VisuallyHiddenText,
} from './bouncer.style';

type Props = {
  className?: string;
  light?: boolean;
  includeScreenReaderProps?: boolean;
};

const Bouncer = (props: Props) => {
  const { className, light, includeScreenReaderProps = true } = props;
  if (includeScreenReaderProps) {
    return (
      <BouncerWrapperStyled className={className} role="alert" aria-busy="true">
        <VisuallyHiddenText>Content is loading</VisuallyHiddenText>
        <BouncerDotStyled light={light} />
        <BouncerDotStyled light={light} />
        <BouncerDotStyled light={light} />
      </BouncerWrapperStyled>
    );
  }
  return (
    <BouncerWrapperStyled className={className}>
      <BouncerDotStyled light={light} />
      <BouncerDotStyled light={light} />
      <BouncerDotStyled light={light} />
    </BouncerWrapperStyled>
  );
};

export default Bouncer;
